<template>
	<section>
		<Header></Header>
		<div class="content-top">
            <img src="../../../static/images/about_us_bg.png" alt="">
            <div class="top-bg-title">
                <p>关于我们</p>
                <p>ABOUT US</p>
            </div>
        </div>
        <div class="content">
            <p>ABOUT US</p>
            <p>关于我们</p>
            <p>古语有云：“有朋自远方来，不亦乐乎”。欧洲的“欧”，朋友的“朋”，2011 年 8 月，我们在中国发布了中文品牌—欧朋，从手机端浏览器开始，发展了全平台的欧朋浏览器，并建立了欧朋广告平台。</p>
            <br/>
            <p>欧朋广告平台与众多核心流量主建立了稳固且互利的合作关系，汇聚了丰富多样的高质量广告资源。资源整合有力地促进了欧朋与全球范围内众多顶尖程序化广告合作伙伴的深度合作。面向未来，欧朋将敏锐把握市场脉搏，积极探寻新的商业机遇，为全球用户提供更智能、精准的广告服务，引领移动互联网广告行业的创新潮流与产业升级。</p>
            <div class="banner-image">
                <img src="/static/images/about_us_1.png" alt="">
            </div>
        </div>
        <div class="content">
            <div class="top">
                <div class="left">
                    <p class="title">何剑</p>
                    <p class="ceo">CEO</p>
                    <p class="border"></p>
                    <p class="doc">何剑先生于 2012 年加入欧朋，拥有丰富的科技公司技术与管理运营经验。毕业于北京航空航天大学计算机专业。</p>
                </div>
                <div class="right">
                    <img src="../../../static/images/about_us_2.png" alt="">
                </div>
            </div>
            <div class="doc-bottom">
                <p class="con">他曾任职于<span style="color: rgba(211, 77, 58, 1);">中华人民共和国公安部网监局、诺基亚中国</span>，见证了中国互联网行业的起步，并以核心成员身份，参与了易到用车等知名互联网公司的创立和发展。作为技术出身的高管，何剑对移动互联网产品的成长与业务发展有着深刻的洞察，在他的带领下，欧朋用户规模快速增长，开拓与知名手机厂商的合作，打造欧朋完整的互联网生态，在新业务发展及海外业务拓展领域，实现了一次又一次突破。</p>
            </div>
        </div>
		<Footer></Footer>
	</section>
</template>

<script>
import Header from '../modules/Header';
import Footer from '../modules/Footer';
export default {
	name: 'AboutUs',
	components: {
		Header,
		Footer
	},
	data() {
		return {
			//
		}
	},
    methods: {
        
    },
	computed: {}
}
</script>

<style scoped>
.content-top {
    position: relative;
    width: 100%;
    height: 1.5rem;
}
img {
    width: 100%;
    height: 100%;
}
.top-bg-title {
    position: absolute;
    top: 0.5rem;
    left: 0.5rem;
    border-bottom: 1px solid rgba(255, 255, 255, 1);
}
.top-bg-title p:nth-child(1) {
    font-size: 0.25rem;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
}
.top-bg-title p:nth-child(2) {
    /* font-size: 0.25rem; */
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
}
.content {
    width: 90%;
    margin: 0.3rem auto 0;
}
.content p:nth-child(1) {
    font-weight: 400;
    color: rgba(255, 113, 113, 1);
}
.content p:nth-child(2) {
    font-size: 0.18rem;
    font-weight: 400;
    margin: 0.06rem 0;
}
.content p:nth-child(3), .content p:nth-child(5){
    /* font-size: 20px; */
    letter-spacing: 2px;
    font-weight: 400;
    line-height: 0.25rem;
    color: rgba(69, 69, 69, 1);
    text-align: justify;
    vertical-align: top;
}
.content .banner-image {
    margin-top: 0.1rem;
}
.content .top {
    display: flex;
}
.content .top .left {
    width: 60%;
}
.content .top .left .title {
    color: black;
}
.content .top .left .ceo {
    color: rgba(255, 113, 113, 1);
}
.content .top .left .border {
    width: 90%;
    height: 2px;
    background-color: rgba(255, 113, 113, 1);
}
.content .top .left .doc {
    width: 90%;
    font-weight: 400;
    letter-spacing: 2px;
    line-height: 0.25rem;
    color: rgba(69, 69, 69, 1);
    text-align: justify;
    vertical-align: top;
}
.content .top .right {
    width: 40%;
}
.content .doc-bottom .con {
    letter-spacing: 2px;
    line-height: 0.25rem;
    margin-top: 0.3rem;
    color: black;
}
</style>


// WEBPACK FOOTER //
// src/components/views/AboutUs.vue